"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnDateFilterConfig = void 0;
const react_1 = require("react");
// TODO - EN-4809 - remove after table migration
/** @deprecated - Use useDateColumnFilterSortConfig instead */
const useColumnDateFilterConfig = () => {
    const getFilterConfig = (0, react_1.useCallback)(({ id }) => ({
        key: id,
        getRange: (filters) => { var _a; return (((_a = filters === null || filters === void 0 ? void 0 : filters.range) === null || _a === void 0 ? void 0 : _a[id]) || { field: id }); },
        setRange: ({ startAt, endAt }) => ({ field: id, startAt, endAt }),
    }), []);
    return getFilterConfig;
};
exports.useColumnDateFilterConfig = useColumnDateFilterConfig;
